import {useState, useEffect} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {Card} from '@/components/Card'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import PurchaseRestrictionForm from './components/PurchaseRestrictionForm'
import {Settings, initialSettings} from './core/_models'
import {getSettings} from './core/_requests'
import {MailerForm} from './components/MailerForm'

const SettingsPage = () => {
  const Breadcrumbs = BreadcrumbsBuilder([{
    title: 'Home',
    path: '/'
  }, { 
    title: 'Passtocard',
    path: '/p2c/dashboard'
  }])

  const [isLoading, setIsLoading] = useState<Boolean>(true)
  const [settings, setSettings] = useState<Settings>(initialSettings)

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getSettings()
        if (res) {
          setSettings(res)
        }
      } catch (e: any) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
    isLoading && load()
  }, [isLoading])

  if (isLoading) {
    return (<>Loading...</>)
  }

  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>
        Settings
      </PageTitle>
      <div className="row gy-5 gx-xl-8">
        <div className="col-xl-6">
          <Card
            title="Mailer"
            collapsable={true}
            id="settings-mailer"
          >
            <MailerForm  mailer={settings.mailer} />
          </Card>
        </div>

        <div className="col-xl-6">
          <Card
            title="Purchase restriction"
            collapsable={true}
            id="purchase-restriction"
          >
            <PurchaseRestrictionForm restrictions={settings.purchaseRestrictions}/>
          </Card>
        </div>

      </div>
    </>
  )
}

export default SettingsPage
